import { render } from "./PartnerBreadcrumbs.vue?vue&type=template&id=47b1099c&scoped=true"
import script from "./PartnerBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./PartnerBreadcrumbs.vue?vue&type=script&lang=js"

import "./PartnerBreadcrumbs.vue?vue&type=style&index=0&id=47b1099c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b1099c"]])

export default __exports__